<template>
  <div class="wnds_bus">
    <div class="wndsb_banner_outbox">
      <el-carousel class="wndsb_banner_box" :interval="4000" type="card" height="420px" indicator-position="none">
        <el-carousel-item v-for="item in bannerList" :key="item">
          <img id="banner_img_slider" :src="item" alt="" srcset="">
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 介绍 -->
    <div class="swhz_introduce_box">
      <div class="wndsb_content">
        <h1>商务合作</h1>
        <p class="swhz_introduce">「为你读诗」是一个以诗歌为起点和纽带的国际文化艺术交流平台，和倡导“诗意生活”的品牌。
          我们致力于为合作伙伴提供具有审美与情感意义的文化解决方案。我们拥有大量优质的文化内容，
          能够帮助合作伙伴提供主题策划、整合传播、嘉宾邀请、活动执行、文化衍生品开发等量身定制的服务。
          我们等待与你一起创造与定义，属于当下的诗意生活方式。</p>
        <ul class="wndsbc_nav tcf-flex tcf-justify-center">
          <li>专业的内容输出能力<p>具有可持续生产文化内容的能力，包括且不限于现有的线上音频、知识付费、出版、文创、场景和互联网文化传播等产品。</p></li> 
          <li>全国最大、跨界嘉宾合作体系<p>拥有广泛的“政要、名人明星、艺术家、人文学者”库，已与全球超过1000位嘉宾合作，与其中多位达成深度合作关系。</p></li> 
          <li>完善、全面的媒体渠道<p>具备线上+线下全渠道传播资源，包括且不限于官方媒体、权威门户媒体；自有APP、微信公众号、微博、FM平台、视频平台；商场、书店、公共交通、剧院、公园等。</p></li> 
          <li>高品质用户基础<p>全网拥有超过1000万精准用户，覆盖并影响超过3000万大众人群。他们来自于中国的主要城市和海外，对文化艺术内容和生活方式有着浓厚的兴趣。</p></li>
        </ul>
        <div style="clear:both"></div>
      </div>
    </div>

    <!-- 线上传播 -->
    <div class="online_box">
      <div class="online">
        <h1 style="padding-top: 80px;">线上传播</h1>
        <p>我们根据合作品牌对文化调性与线上传播的需求，为其策划主题与创意、邀请嘉宾，以及制作原创、<br>文字、图片、音乐、视频等内容，并在自有媒体矩阵和外部渠道进行全网传播。</p>
        <!-- <img src="../../../static/img/images/wuliangye_10.png" alt=""> -->
      </div>
    </div>

    <!-- 线下场景 -->
    <div class="offline_box">
      <div class="offline" >
        <h1>线下场景</h1>
        <p>我们拥有专业、丰富的线下场景产品策划与打造能力。
          从艺术雅宴、文艺沙龙到主题音乐会、生活节，
          <br>我们运用更跨界、更具通感的诗意、人文表达方式，为合作品牌创造独具其品牌风格的文化美学价值。</p>

        <!-- 艺术雅宴 -->
        <div class="off_con tcf-flex tcf-justify-justify" style="padding-top: 90px;">
          <div class="offCon_left" >
            <h2 style="text-align:left;">艺术雅宴</h2>
            <hr>
            <p>我们擅长根据合作伙伴的个性化需求，量身打造艺术雅宴：每场皆有专属的主题呈现、精美的制作物、特别的环节及互动设计。
              精致优雅的环境与美食，专业贴心的贵宾服务，让受邀来到现场的嘉宾们享受全方位的诗意体验。</p>
          </div>
          <div class="offCon_right">
            <img src="../../../static/img/2 艺术雅宴.jpg" alt="" >
          </div>
        </div>

        <!-- 人文艺术讲座&沙龙 -->
        <div class="off_con tcf-flex tcf-justify-justify" style="padding-top: 70px;">
          <div class="offCon_right ">
            <img src="../../../static/img/3 人文艺术讲座-黄怒波.jpeg" alt="" >
          </div>
          <div class="offCon_left" >
            <h2 style="text-align:left;">人文艺术讲座&沙龙</h2>
            <hr>
            <p>我们致力于根据不同企业/团体的需要，为其定制文化活动：无论是进行品牌文化传播、为员工提供福利，或是为学生/会员提供艺术熏陶等，
              我们以严谨、专业的知识能力和活动执行能力，为大众爱好者带来美的享受，让诗歌和文化回归生活。</p>
          </div>
        </div>

        <!-- 诗歌音乐会 -->
        <div class="off_con tcf-flex tcf-justify-justify" style="padding-top: 70px;">
          <div class="offCon_left" >
            <h2 style="text-align:left;">诗歌音乐会</h2>
            <hr>
            <p>我们致力于诗歌及各类文学作品艺术与音乐、舞蹈、戏剧等多元艺术形式间的跨界创作：通过各种形式的相互对话、启发，诗歌拥有了艺术的语言，艺术也获得了诗意的生命力。
              我们已经成功举办了数十场以诗歌和文学作品为主题的音乐会，得到了上万观众的肯定与支持。</p>
          </div>
          <div class="offCon_right">
            <img src="../../../static/img/4 诗歌音乐会.png" alt="" >
          </div>
        </div>

        <!-- “诗歌漫游城市”公益项目 -->
        <div class="off_con tcf-flex tcf-justify-justify" style="padding-top: 70px;padding-bottom: 110px;">
          <div class="offCon_right ">
            <img src="../../../static/img/5.jpg" alt="" >
          </div>
          <div class="offCon_left" >
            <h2 style="text-align:left;">“诗歌漫游城市”公益项目</h2>
            <hr>
            <p>“诗歌漫游城市”是我们在全国范围内发起的一项公益文化活动。我们将包括诗歌在内的人文内容引入城市公共空间，包括且不限于巴士、地铁、机场、商城等场所。
              我们已与深圳市交通委和深圳市巴士集团达成长期战略合作关系。</p>
          </div>
        </div>
      </div>
      
      <!-- 整合营销 -->
      <div class="integratedMarketing_box">
        <div class="markBox">
          <h1>整合营销</h1>
          <p>我们将合作品牌的传播诉求进行场景化的想象，策划有温度的传播故事，并整合线上与线下资源定制社会化营销活动，<br>增加品牌与用户的情感互动，提升品牌的文化与公益形象。</p>
          <div class="mark_swiper">
            <el-carousel class="mark" :interval="4000"  height="960px" indicator-position="none">
              <el-carousel-item >
                <div class="shadow"><img  src="../../../static/img/6 自如海燕计划.png" alt="" srcset=""></div>
                <h2>自如2019海燕计划 X 「为你读诗」</h2>
                <p>2019年的5月初夏，我们联合自如海燕计划，在毕业季做了以“给青年人的诗”为主题的特别合作，在线上邀请毛不易参与读诗，并号召<br>用户通过微信H5互动传播；
                  线下在清华大学等全国多所高校内落地朗读亭，以一种更诗意的方式与更多的年轻人建立沟通，为青年人助力。</p>
              </el-carousel-item>
              <el-carousel-item >
                <div class="shadow"><img  src="../../../static/img/7 VIPKID.png" alt="" srcset=""></div>
                <h2>VIPKID X 「为你读诗」</h2>
                <p>2018年3月5日，我们与在线少儿英语教育公司“VIPKID”共同发起“宝贝，为你读诗”公益项目。VIPKID代言人周涛与创始人米雯娟参与读诗，<br>并邀请社会各行业人士与用户共同加入，
                  并在同年4月前往大理举办了一场以“宝贝，为你读诗”为主题的诗歌音乐会，让诗歌与孩子们在一起。</p>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>

      <!-- 品牌客户 -->
      <div class="customers_box">
        <div class="customers">
          <h1>品牌客户</h1>
          <img src="../../../static/img/images/customers_22.png" alt="">
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "advertising",
	data(){
		return{
			bannerList: [
        require("../../../static/img/1 五粮液春节.png"),
        require("../../../static/img/2 飞利浦.jpeg"),
        require("../../../static/img/自如.png")
      ]
		}
  },
  created(){
		this.$parent.activeIndex = 'advertising'
  },
}
</script>
<style scoped>
.wnds_bus{
  display: inline-table;
  width: 100%;
  background: #fff;
}
.wndsb_banner_outbox {
  padding-top: 148px;
  padding-bottom: 148px;
  background: url(../../../static/img/bus_banner_bg.60f411c.png);
  background-size: 100% 100%;
}
.wndsb_banner_box {
    width: 1140px;
    margin: 0 auto;
}
#banner_img_slider{
  display: block;
  width: 717px;
  height: 420px;
}
.wndsb_banner_box .el-carousel__item {
    width: 717px;
    height: 420px;
}
.wndsb_banner_box .el-carousel__item--card.is-active {
    margin-left: -40px;
}
.wndsb_content_box {
    width: 100%;
    background-color: #fcfcfe;
}
.swhz_introduce_box,.customers_box{
  width: 100%;
  background: #fafafa;
  padding-bottom: 89px;
}
.wndsb_content {
    width: 1140px;
    margin: 0 auto;
    padding-top: 90px;
    text-align: center;
}
.swhz_introduce_box h1,.online h1,.offline h1,.markBox h1,.customers h1{
  font-size: 26px;
  line-height: 55px;
  color:#464646;
  font-weight: 500;
  letter-spacing: 5px;
}
.swhz_introduce_box .swhz_introduce{
  font-size: 16px;
  line-height: 30px;
  color:#464646;
  text-align: left;
  margin-top: 15px;
}
.wndsbc_nav {
    margin: 0 auto;
    margin-top: 80px;
}
.wndsbc_nav li {
    width: 363px;
    padding-top: 18px;
    /* padding-bottom: 5px; */
    font-size: 16px;
    line-height: 16px;
    color: #4c4c4c;
}
.wndsbc_nav li p {
    font-size: 12px;
    line-height: 18px;
    color: #8c8c8c;
    margin: 18px 8px;
}
.wndsbc_nav li:nth-child(n+2) {
    border-left:2px solid #cae3a6;
}

.online_box{
  text-align: center;
  background: #fcfcfe;
}
.online{
  text-align: center;
}
.online p,.offline p,.markBox p{
  font-size: 14px;
  line-height: 25px;
  color:#464646;
  margin-top: 15px;
}
.online img{
  margin-top: 77px;
  width: 100%;
  height: 100%;
}
.offline_box{
  padding-top: 90px;
  text-align: center;
  background: #fafafa;
}
.offline{
  width: 1440px;
  margin: 0 auto;
  /* margin-bottom: 300px; */
  /* text-align: center; */
}
.offCon_left{
  width: 720px;
  height: 477px;
  /* margin-left: 90px; */
  padding-left: 90px;
}
.offCon_left h2{
  font-size: 22px;
  color: #464646;
  margin-top: 110px;
  text-align: left;
}
.offCon_left hr{
  width: 117px;
  height: 1px;
  background: #ccc;
  margin: 40px 0;
}
.offCon_left p{
  text-align: left;
  margin-right: 105px;
}
.offCon_right{
  width: 820px;
}
.offCon_right img{
  width: 100%;
  height: 100%;
}

.integratedMarketing_box{
  width: 100%;
  background: #fff;
}
.markBox{
  width: 1440px;
  margin:  0 auto;
}
.markBox h1{
  padding-top: 80px;
}
.mark_swiper{
  margin-top: 80px;
}
.mark h2{
  margin-top: 80px;
  font-size: 24px;
  color: #464646;
  letter-spacing: 2px;
  font-weight: 500;
}
.mark p{
  font-size: 14px;
  line-height: 25px;
  color: #464646;
  margin-top: 30px;
  letter-spacing: 1px;
}
.shadow{
  text-align: center;
  margin:  0 auto;
   width:375px;
   height:667px;
   box-shadow: 20px 20px 70px -30px gray;
}
.shadow img{
  width: 100%;
  height: 100%;
}
.customers h1{
  padding-top: 90px;
  padding-bottom: 75px;
}


</style>





// WEBPACK FOOTER //
// src/components/page/Advertising.vue